import { createSelector } from 'reselect'

import API from '../../api/api'

const PROPERTY_MANAGERS_LOAD = 'PROPERTY_MANAGERS_LOAD'
const PROPERTY_MANAGERS_CREATE = 'PROPERTY_MANAGERS_CREATE'
const PROPERTY_MANAGERS_UPDATE = 'PROPERTY_MANAGERS_UPDATE'
const PROPERTY_MANAGERS_DELETE = 'PROPERTY_MANAGERS_DELETE'

const initialState = {
  propertyManagers: [],
}

const propertyManagersReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROPERTY_MANAGERS_LOAD:
      return {
        ...state,
        propertyManagers: action.propertyManagers,
      }
    case PROPERTY_MANAGERS_CREATE: {
      return {
        ...state,
        propertyManagers: [action.data, ...state.propertyManagers],
      }
    }
    case PROPERTY_MANAGERS_UPDATE: {
      return {
        ...state,
        propertyManagers: state.propertyManagers.map((pm) => {
          if (pm.id === action.data.id) {
            return action.data
          } else {
            return pm
          }
        }),
      }
    }
    case PROPERTY_MANAGERS_DELETE: {
      return {
        ...state,
        propertyManagers: state.propertyManagers.filter((pm) => pm.id !== action.id),
      }
    }
    default:
      return state
  }
}

export const fetchPropertyManagers = () => {
  return (dispatch) =>
    API.getAllPropertyManagers()
      .then((res) => {
        dispatch(loadManagers(res))
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const fetchPropertyManagersByBuildingId = (buildingId) => {
  return (dispatch) =>
    API.getAllPropertyManagersByBuildingId(buildingId)
      .then((res) => {
        dispatch(loadManagers(res))
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const createPropertyManager = (data) => {
  return (dispatch) =>
    API.createNewManagementUser(data, 'propertyManager')
      .then((res) => {
        if (!res.errCode) dispatch({ type: PROPERTY_MANAGERS_CREATE, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const updatePropertyManager = (data, id) => {
  return (dispatch) =>
    API.updateManagementUserData(data, id, 'propertyManager')
      .then((res) => {
        if (!res.errCode) dispatch({ type: PROPERTY_MANAGERS_UPDATE, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => {
        console.dir(err)
        return Promise.reject(err)
      })
}

export const deletePropertyManager = (id) => {
  return async (dispatch) => {
    try {
      await API.deleteManagementUserData(id, 'propertyManager')
      dispatch({ type: PROPERTY_MANAGERS_DELETE, id })
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const loadManagers = (propertyManagers) => {
  return {
    type: PROPERTY_MANAGERS_LOAD,
    propertyManagers,
  }
}

export const selectPropertyManagers = (state) => state.propertyManagers.propertyManagers

export const selectPropertyManagerById = createSelector(
  selectPropertyManagers,
  (propertyManagers) => (propertyManagerId) => {
    if (propertyManagerId === 'new') {
      return {
        user: {},
      }
    }
    return (
      propertyManagers.find((pm) => pm.id === parseInt(propertyManagerId)) ||
      propertyManagers[0] || { user: {} }
    )
  },
)

export const selectPropertyManagerOptions = (state) =>
  state.propertyManagers.propertyManagers
    .filter((pm) => pm.user)
    .map((pm) => ({
      value: pm.user.id,
      label: `${pm.user.firstName} ${pm.user.lastName}`,
    }))

export default propertyManagersReducer
